import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05d663f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "年", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "月", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.componentId,
    class: "input-date"
  }, [
    _createVNode(_component_AppInput, {
      modelValue: _ctx.state.y,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.y) = $event)),
      min: 0,
      max: 9999,
      label: "年",
      type: "number",
      "input-id": `${_ctx.componentId}-y`,
      styled: _ctx.styled,
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.context.emit('blurCheck'))),
      class: "input-date-firefox"
    }, null, 8, ["modelValue", "input-id", "styled"]),
    _hoisted_2,
    _createVNode(_component_AppInput, {
      modelValue: _ctx.state.m,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.m) = $event)),
      min: 1,
      max: 12,
      "input-id": `${_ctx.componentId}-m`,
      label: "月",
      type: "number",
      styled: _ctx.styled,
      class: "input-date-firefox"
    }, null, 8, ["modelValue", "input-id", "styled"]),
    _hoisted_3,
    _createVNode(_component_AppInput, {
      modelValue: _ctx.state.d,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.d) = $event)),
      min: 1,
      max: 31,
      "input-id": `${_ctx.componentId}-d`,
      label: "日",
      type: "number",
      styled: _ctx.styled,
      class: "input-date-firefox"
    }, null, 8, ["modelValue", "input-id", "styled"]),
    _hoisted_4
  ], 8, _hoisted_1))
}